module.exports = __webpack_public_path__ + "static/media/polygon-up.d3ac7d28.svg";